import { render, staticRenderFns } from "./AcessarPenalidadesPedidoDocumentosListagem.vue?vue&type=template&id=3339df61&scoped=true"
import script from "./AcessarPenalidadesPedidoDocumentosListagem.vue?vue&type=script&lang=js"
export * from "./AcessarPenalidadesPedidoDocumentosListagem.vue?vue&type=script&lang=js"
import style0 from "./AcessarPenalidadesPedidoDocumentosListagem.vue?vue&type=style&index=0&id=3339df61&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3339df61",
  null
  
)

export default component.exports